module.exports = __webpack_public_path__ + "img/burkina_faso.5ec5028.webp";